import { Fog, Color } from "three";
import Game from "./Game";

import Auth from "./Auth";
import UserControlsOrientation from "./Controls/UserControlsOrientation";
import UserControlsKeyboard from "./Controls/UserControlsKeyboard";
import { initScore } from "./UI/score";

const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    );

const isStereoViewer = false; // TODO optionally allow google cardboard

const auth = new Auth();
const game: Game = new Game(auth);

function showMenu(): void {
    const pausemenu: HTMLElement | null = document.getElementById("pausemenu");
    const instructions: HTMLElement | null =
        document.getElementById("instructions");
    if (instructions && pausemenu) {
        pausemenu.style.display = "block";
        instructions.style.display = "";
    }
}

function hideMenu(): void {
    const pausemenu: HTMLElement | null = document.getElementById("pausemenu");
    const instructions: HTMLElement | null =
        document.getElementById("instructions");
    if (instructions && pausemenu) {
        instructions.style.display = "none";
        pausemenu.style.display = "none";
    }
}

function openFullscreen(): void {
    if (game.isFullscreen) {
        const elem = game.renderer.domElement;
        elem.requestFullscreen?.();
        elem.style.width = "100%";
        elem.style.height = "100%";
    }
}

let userControlsOrientation: UserControlsOrientation | null = null;

// TODO move to game
const userControlsKeyboard = new UserControlsKeyboard(
    game.camera,
    game.scene,
    game.currentPlayer,
    game.currentPlayer.physics,
    showMenu,
    hideMenu
);

function startGame() {
    openFullscreen();
    hideMenu();
    setTimeout(() => {
        if (isMobile) {
            if (!userControlsOrientation)
                userControlsOrientation = new UserControlsOrientation(
                    game.camera,
                    game.scene,
                    game.currentPlayer,
                    game.currentPlayer.physics
                );
            game.currentPlayer.setControls(userControlsOrientation);
        } else {
            game.currentPlayer.setControls(userControlsKeyboard);
        }
    }, 300);
}

function setupInstructions() {
    const instructions: HTMLElement | null =
        document.getElementById("instructions");
    if (instructions !== null) {
        instructions.addEventListener("click", startGame, false);
        instructions.addEventListener("touchend", startGame, false);
    }
}

function onWindowResize(): void {
    const elem = game.renderer.domElement;
    const sceneWidth = window.innerWidth;
    const sceneHeight = elem.offsetHeight;
    game.camera.aspect = sceneWidth / sceneHeight;
    game.camera.updateProjectionMatrix();
    game.renderer.setSize(sceneWidth, sceneHeight);
    game.effect.setSize(window.innerWidth, window.innerHeight);
}

function init(): void {
    game.scene.fog = new Fog(
        game.world.getSkyColour(),
        game.world.fogNear,
        game.world.fogFar
    );

    game.world.add(game.currentPlayer);

    game.renderer.setClearColor(game.world.getSkyColour(), 1);
    game.renderer.setSize(window.innerWidth, window.innerHeight);

    document.body.appendChild(game.renderer.domElement);

    setupInstructions();
    window.addEventListener("resize", onWindowResize, false);
}

function animate(): void {
    const { scene, world, renderer, camera, effect } = game;
    const time = performance.now();
    const delta = (time - game.prevTime) / 1000;

    scene.updateMatrixWorld();

    requestAnimationFrame(animate);

    world.update(delta);

    const skyColour = world.getSkyColour();

    if (scene.fog?.color !== new Color(skyColour)) {
        renderer.setClearColor(skyColour, 1);
        scene.fog = new Fog(skyColour, world.fogNear, world.fogFar);
    }

    (isStereoViewer ? effect : renderer).render(scene, camera);
    game.update(delta);

    game.prevTime = time;
}

init();
animate();
initScore(game.currentPlayer);
